import React, { useState, useMemo, useEffect } from "react";
import _ from 'lodash';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    Box,
    Typography,
    IconButton
} from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import CloseIcon from '@mui/icons-material/Close';
import { convertArrayToDictionary } from '../../../common/utils'


const PipelineOutputModel = ({ open, onClose, rawData, reviews }) => {

    const reviewsDic = React.useMemo(() => convertArrayToDictionary(reviews, 'reviewId'), [reviews])
    const bindData = () => {

        // let segments = rawData.segments;
        let segments = convertArrayToDictionary(rawData.segments, 'ReviewId');
        let summarize = convertArrayToDictionary(rawData.summarize, 'ReviewId');
        let summarizeSegments = convertArrayToDictionary(rawData.summarizeSegments, 'ReviewId');

        let topics = _.groupBy(rawData.topics, 'ReviewId');
        let topicsWithDesc = _.groupBy(rawData.topicsWithDesc, 'ReviewId');

        let rows = [];
        _.map(segments, (it, reviewId) => {
            let maxValue = _.max([segments[reviewId]?.Segments?.length,
            summarize[reviewId]?.Liked?.length, summarizeSegments[reviewId]?.Liked?.length,
            summarize[reviewId]?.Disliked?.length, summarizeSegments[reviewId]?.Disliked?.length,
            topics[reviewId]?.length, topicsWithDesc[reviewId]?.length])

            _.map(_.range(maxValue), (i) => {
                rows.push({
                    reviewId: reviewId, 
                    reviewText: reviewsDic[reviewId]?.reviewText,
                    sequence: it.Number, segments: segments[reviewId]?.Segments[i],
                    segmemtLiked: summarizeSegments[reviewId]?.Liked?.[i],
                    segmemtDisLiked: summarizeSegments[reviewId]?.Disliked?.[i],
                    summarizeLiked: summarize[reviewId]?.Liked?.[i],
                    summarizeDisLiked: summarize[reviewId]?.Disliked?.[i],
                    topic: topics[reviewId]?.[i]?.Topic,
                    topicWithDesc: topicsWithDesc[reviewId]?.[i]?.Topic,
                }
                )
            })
        })
        return rows;

    }
    const data = React.useMemo(() => bindData(), [rawData, reviewsDic])

    const renderCell = (cell) => {

        switch (cell.column.columnDef.accessorKey) {
            case "address":
                const add1 = cell.row.original.addressLine1;
                const add2 = cell.row.original.addressLine2;
                return <Box>{add1 + (add2 ? (' ' + add2) : '')}</Box>
            default:
                return (
                    <Typography sx={{ whiteSpace: "pre-wrap", marginTop: "-5px" }}>
                        {cell.renderedCellValue}
                    </Typography>
                );
        }
    };
    const columns = useMemo(
        () => [
            {
                header: 'ReviewId',
                accessorKey: "reviewId",
                id: "reviewId",
                Cell: renderCell,
            },
            {
                header: 'Review Text',
                accessorKey: "reviewText",
                id: "reviewText",
                Cell: renderCell,
            },
            {
                header: 'Sequence',
                accessorKey: "sequence",
                id: "sequence",
                Cell: renderCell,
            },
            {
                header: 'Segments',
                accessorKey: "segments",
                id: "segments",
                Cell: renderCell,
            },
            {
                header: 'Like Summarize',
                accessorKey: "summarizeLiked",
                id: "summarizeLiked",
                Cell: renderCell,
            },
            {
                header: 'Dis Like Summarize',
                accessorKey: "summarizeDisLiked",
                id: "summarizeDisLiked",
                Cell: renderCell,
            },
            {
                header: 'Like Summarize Segments',
                accessorKey: "segmemtLiked",
                id: "segmemtLiked",
                Cell: renderCell,
            },
            {
                header: 'Dis Like Summarize Segments',
                accessorKey: "segmemtDisLiked",
                id: "segmemtDisLiked",
                Cell: renderCell,
            },
            {
                header: 'Topics',
                accessorKey: "topic",
                id: "topic",
                Cell: renderCell,
            },
            {
                header: 'Topics (With Desc)',
                accessorKey: "topicWithDesc",
                id: "topicWithDesc",
                Cell: renderCell,
            },
        ], [data])

    return (
        <Dialog open={open} onClose={onClose} maxWidth fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }} >
                <Typography variant="h5">Tabular Output</Typography>
                <IconButton shape='rounded' color='secondary' onClick={onClose}><CloseIcon /></IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <MaterialReactTable
                    columns={columns}
                    data={data ?? []}
                    enableStickyHeader
                    // enableStickyFooter
                    // enableRowSelection={!selectAll}
                    // enablePagination={false}
                    // enableSorting={true}
                    // // enableMultiRowSelection
                    // enableColumnActions={false}
                    // enableFullScreenToggle={false}
                    // enableDensityToggle={false}
                    // enableColumnFilters={false}
                    // enableTopToolbar={false}
                    // enableBottomToolbar={false}
                    // getRowId={row => row.locationId}
                    // onRowSelectionChange={setRowSelection}
                    // state={selectAll ? null : { rowSelection }}
                    // muiTableProps={muiTableProps}
                    muiTableContainerProps={{
                        "aria-label":'Table PRops',
                        sx: {
                           height:'calc(100vh - 393px)',
                           overflowY:'auto'
                        }
                    }}
                // muiTableHeadCellProps={muiTableHeadCellProps}
                // muiTableBodyCellProps={muiTableBodyCellProps}
                // muiTableBodyRowProps={muiTableBodyRowProps}
                // muiTableHeadRowProps={muiTableHeadRowProps}
                // muiTableHeadProps={muiTableHeadProps}
                />
            </DialogContent>
            <Divider />
            <DialogActions
                sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
            >
                <Button
                    onClick={onClose}
                    size="small"
                    variant="outlined"
                // color="error"
                // sx={{ ml: 2 }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PipelineOutputModel;
